"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./MFSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import { Link } from "react-router-dom";

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/inventory.webp" alt="Inventory Management" />,
    title: "INVENTORY MANAGEMENT SOFTWARE",
    desc: "Efficiently manage your inventory with precision and ease. An advanced inventory management system empowers you to track stock levels, minimize wastage, and optimize resources for enhanced productivity."
  },
  {
    icon: <img src="/icons/production.webp" alt="Production Planning" />,
    title: "PRODUCTION PLANNING SOFTWARE",
    desc: "Take control of your production processes like never before. With production planning software, you can schedule tasks seamlessly, maximize resource utilization, and minimize downtime for uninterrupted operations."
  },
  {
    icon: <img src="/icons/quality.webp" alt="Quality Control" />,
    title: "QUALITY CONTROL SOFTWARE",
    desc: "Deliver excellence with every product with quality control solutions to ensure consistency, regulatory compliance, and ultimate customer satisfaction through meticulous inspection and monitoring."
  },
  {
    icon: <img src="/icons/supply.webp" alt="Supply Chain" />,
    title: "SUPPLY CHAIN MANAGEMENT SOFTWARE",
    desc: "Navigate the complexities of your supply chain with confidence. We help your supply chain software provide unparalleled visibility, foster collaboration, and drive efficiency throughout your entire network, from procurement to delivery."
  }
];

export default function ManufacturingSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar */}
      <div className="manufacturing-navbar">
        <div className="container">
          <ul>
            {sectionsToHighlight.map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="manufacturing-section" id="solutions">
        <div className="container">
          <div className="manufacturing-stats-row" data-aos="fade-up">
            {stats.map((stat, i) => (
              <div className="manufacturing-stat" key={i}>
                <div className="manufacturing-stat-value">{stat.value}</div>
                <div className="manufacturing-stat-label">{stat.label}</div>
              </div>
            ))}
            <BlueSectionDivider />
          </div>

          <div className="manufacturing-title-group" data-aos="fade-up">
            <div className="manufacturing-title">DIGITAL SOLUTIONS</div>
            <div className="manufacturing-title-blue">
              FOR THE DIFFERENT MANUFACTURING AREAS
            </div>
          </div>

          <div className="manufacturing-cards-grid">
            {cards.map((card, i) => (
              <div
                className="manufacturing-card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={100 + i * 100}
              >
                <div className="manufacturing-card-icon">{card.icon}</div>
                <div className="manufacturing-card-title">{card.title}</div>
                <div className="manufacturing-card-desc">{card.desc}</div>
              </div>
            ))}
          </div>

          <div
            className="manufacturing-cta-row"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <button className="manufacturing-cta-btn">
              <Link to="/contact">
                GET STARTED WITH YOUR MANUFACTURING DIGITAL PRODUCT
              </Link>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
